import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfUncoveredOversized extends AbstractProductType {

  name = 'self_uncovered_oversized'
  title = 'Self Uncovered Oversized'

  oversized = true

  format = ProductTypeFormat.Uncovered

}
